import { createContext } from 'react';
import type { ENUM_CARD_EVENT_METRIC } from '@linkie/domain';
import type { ENUM_EMAIL_COLLECTION_EVENT } from '@linkie/shared';

export type DateRange = { start: string; end: string };

export type FilterKey = 'source' | 'country' | 'device' | 'browser' | 'os';
export type UpdateFilterFn = (key: FilterKey, value: string) => void;

export const AnalyticsContext = createContext<
  | {
      captureVisitorMetric: () => Promise<void>;
      enrichVisitorMetric: () => Promise<void>;
      captureBannerClick: () => Promise<void>;
      captureCtaClick: () => Promise<void>;
      captureCardMetric: (cardId: string, event: ENUM_CARD_EVENT_METRIC) => Promise<void>;
      capturePostMetric: (postId: string, event: ENUM_CARD_EVENT_METRIC) => Promise<void>;
      captureEmailCollectionMetric: (event: ENUM_EMAIL_COLLECTION_EVENT) => Promise<void>;
      dateFilter: DateRange;
      setDateFilter: (cardType: DateRange) => void;
      updateFilter: UpdateFilterFn;
      filters: {
        source: string;
        country: string;
        device: string;
        browser: string;
        os: string;
      };
    }
  | undefined
>(undefined);
